import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealApi, dealQueryKeys } from '@crm/entities/deal';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

import type { TDeal } from '@crm/entities/deal';
import type { ICommentMessage } from '@entities/message';

export const useDeleteDealCommentMutation = ({ dealId }: { dealId: TDeal['id'] }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: dealQueryKeys.deleteComment(dealId),
        mutationFn: (commentId: ICommentMessage['id']) =>
            dealApi.deleteDealComment({ dealId, commentId }),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: dealQueryKeys.detail(dealId) });
        },
        onError: (error) => {
            toastManager.onError({
                title: getApiErrorMessage(
                    error,
                    t('crm.dealDetailsContent.notesBlock.errors.delete')
                ),
            });
        },
    });
};
